import './BrandsGrid.css';

const LOGOS = [
  { file: '4mation skins.png',      alt: '4mation Skins' },
  { file: '7days natural.png',      alt: '7 Days Natural' },
  { file: 'Couture By Manju.png',   alt: 'Couture By Manju' },
  { file: 'Economic granite.png',   alt: 'Economic Granite' },
  { file: 'Elite Global.png',       alt: 'Elite Global' },
  { file: 'HOA CONNECT.png',        alt: 'HOA Connect' },
  { file: 'Kriteyu Hrlth Care.png', alt: 'Kriteyu Health' },
  { file: 'Novacrib.png',           alt: 'Novacrib' },
  { file: 'Nubokind.png',           alt: 'Nubokind' },
  { file: 'Pathivy.png',            alt: 'Pathivy' },
  { file: 'Psypathology.png',       alt: 'Psypathology' },
  { file: 'Putchi.png',             alt: 'Putchi' },
  { file: 'Sell Abroad.png',        alt: 'Sell Abroad' },
  { file: 'SmartFSA.png',           alt: 'SmartFSA' },
  { file: 'SuperErgo.png',          alt: 'SuperErgo' },
  { file: 'Verity Verse.png',       alt: 'Verity Verse' },
];

const ROW1 = LOGOS.slice(0, 8);
const ROW2 = LOGOS.slice(8);

const src = (file) => `/client-logos/${encodeURIComponent(file)}`;

function LogoItem({ logo }) {
  return (
    <div className="brand-scroll-item">
      {/* Framer-style corner dot decorators */}
      <span className="bg-corner bg-tl" />
      <span className="bg-corner bg-tr" />
      <span className="bg-corner bg-bl" />
      <span className="bg-corner bg-br" />

      <img
        src={src(logo.file)}
        alt={logo.alt}
        className="brand-logo"
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    </div>
  );
}

export default function BrandsGrid() {
  return (
    <section className="brands-grid-section">
      <div className="section-header">
        <h2>
          <span className="heading-white">Trusted by </span>
          <span className="heading-accent">Top Brands</span>
        </h2>
      </div>

      {/* full-bleed masked marquee wrapper */}
      <div className="brands-mask-wrap">
        {/* Row 1 — scrolls right */}
        <div className="brands-scroll-row brands-scroll-right">
          <div className="brands-scroll-track">
            {[...ROW1, ...ROW1, ...ROW1].map((logo, i) => (
              <LogoItem key={i} logo={logo} />
            ))}
          </div>
        </div>

        {/* Row 2 — scrolls left */}
        <div className="brands-scroll-row brands-scroll-left">
          <div className="brands-scroll-track">
            {[...ROW2, ...ROW2, ...ROW2].map((logo, i) => (
              <LogoItem key={i} logo={logo} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
